import axios from 'axios'

const { VUE_APP_BASE_URL } = process.env

export function request(config) {
  const instance = axios.create({
    baseURL: VUE_APP_BASE_URL,
  })

  // 2.2响应拦截
  instance.interceptors.response.use(
    (res) => {
      return res.data
    },
    (err) => {
      console.log(err)
    }
  )
  return instance(config)
}
